// extracted by mini-css-extract-plugin
export default {"card":"pY-z","carouselContainer":"qY-z","carouselContent":"rY-z"};